module.exports = __webpack_public_path__ + "img/o365_sso.2eb3856a.svg";